import React from 'react';
import {Link} from "react-router-dom";
import { useTranslation } from "react-i18next";

const   Nav = () => {
    const { t } = useTranslation('enterprise');
    return (
        <ul className="mainmenu">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/entreprise-mission">{t('header.entrepriseMission')}</Link></li>
            <li><Link to="/benefits">{t('header.avantages')}</Link></li>
            <li><Link to="/functioning">{t('header.fonctionnement')}</Link></li>
            <li><Link to="/offers">{t('header.offres')}</Link></li>
        </ul>
    )
}
export default Nav;
